import React, { ReactElement } from 'react';

import { Assets } from '../../../../../utils/assets';
import { DOWNLOAD_APPLE_CHIP_MAC_URL, DOWNLOAD_INTEL_CHIP_MAC_URL } from '../../constants';
import * as S from './DownloadCard.styles';

export const DownloadCard = (): ReactElement => {
  return (
    <S.Wrapper>
      <S.ContentContainer>
        <S.LeftTitleContainer>
          Download Brain.fm for macOS
        </S.LeftTitleContainer>

        <S.LeftDescriptionContainer>
          Experience the power of science-backed music without disrupting your daily flow.
        </S.LeftDescriptionContainer>

        <S.LeftButtonContainer>
          <S.ButtonContainer>
          <S.Button href={DOWNLOAD_INTEL_CHIP_MAC_URL}>
              <S.ButtonIcon src={'https://cdn.brain.fm/icons/apple-black.svg'} />
              MAC WITH INTEL CHIP
            </S.Button>
            <S.ButtonNote>Mac OS X 10.5+</S.ButtonNote>
          </S.ButtonContainer>

          <S.ButtonContainer>
          <S.Button href={DOWNLOAD_APPLE_CHIP_MAC_URL}>
              <S.ButtonIcon src={'https://cdn.brain.fm/icons/apple-black.svg'} />
              MAC WITH APPLE CHIP
            </S.Button>
            <S.ButtonNote>Mac OS 11+</S.ButtonNote>
          </S.ButtonContainer>
        </S.LeftButtonContainer>
      </S.ContentContainer>
      <S.Image alt="Download Brain.fm Desktop for macOS" src={Assets.images.downloadMacbook.url} />
    </S.Wrapper>
  );
};
